var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowDown = function SvgArrowDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    className: "arrow-down_svg__svg-icon",
    viewBox: "0 0 64 64"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M29.987 52.1 14.401 36.513l-2.836 2.837L32 59.785l20.435-20.434-2.836-2.837-15.586 15.585V3.513h-4.026z",
    clipRule: "evenodd"
  })));
};
export { SvgArrowDown as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgNjQgNjQiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgY2xhc3M9InN2Zy1pY29uIj48cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTI5Ljk4NyA1Mi4wOTkzTDE0LjQwMSAzNi41MTM1TDExLjU2NTQgMzkuMzUxTDMyIDU5Ljc4NTNMNTIuNDM0NiAzOS4zNTFMNDkuNTk5MSAzNi41MTM1TDM0LjAxMyA1Mi4wOTkzVjMuNTEyOTRIMjkuOTg3VjUyLjA5OTNaIiBmaWxsPSJjdXJyZW50Q29sb3IiLz48L3N2Zz4=";